import createNetworkingClient from 'utils/networking-client';
import { devLog } from 'utils/dev-utils';
import { StatusCodes } from 'http-status-codes';
import { isConsentsCreateAction } from '../../apps/Onboarding/shared/onboardingUtils';

/**
 *
 * Makes a GET XHR call to retrieve next steps if the current step does not update permissions.
 *
 * Makes a POST XHR call to create new permissions and responds with the next step when the current
 * step updates permissions.
 *
 * @param {Object} arg
 * @param {string} arg.step - one of onboardingConstants.REGISTRATION_FLOW or onboardingConstants.CONSENTS_FLOW
 * @param {string} arg.action - one of ActionButton.ACTIONS
 * @param {string} arg.permissionType - one of permissionTypes.PERMISSION_TYPES
 * @returns {Object} response
 * @returns {boolean} response.nextStep - next step
 * */
export const consentsNextStep = ({ step, action, permissionType }) => {
  return new Promise((resolve, reject) => {
    const url = '/athlete/consents/next_step';
    let params = {
      id: step
    };
    let method = 'GET';
    let data = {};

    if (isConsentsCreateAction(action)) {
      method = 'POST';
      params = {};
      data = {
        id: step,
        permission_type: permissionType,
        consent: action
      };
    }

    createNetworkingClient()
      .request({
        method,
        url,
        params,
        data
      })
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          resolve(response.data);
        } else {
          devLog(response.error);
          reject(response.error);
        }
      })
      .catch((e) => {
        devLog(e);
        reject(e);
      });
  });
};

export default { consentsNextStep };
